module.exports = __webpack_public_path__ + "img/erin-patterson13.34ddfe5e.png";